

import '@fontsource/roboto/300.css';

import '@fontsource/roboto/400.css';

import '@fontsource/roboto/500.css';

import '@fontsource/roboto/700.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

import { LicenseInfo } from '@mui/x-license';

import { PayloadAction } from '@reduxjs/toolkit';

import { AppRoutes } from 'appRoutes';

import { Broadcaster } from 'broadcaster';

import { setAppDispatch, setIOInstance } from 'cdx-common';

import { createRoot } from 'react-dom/client';

import { Provider } from "react-redux";

import { PersistGate } from 'redux-persist/integration/react';

import { appStore, persistor } from 'store';

import { AppStatus } from 'views/AppStatus';

import { GeoLocalizer } from 'views/GeoLocalizer';

import { Persistor } from 'views/persistor/Persistor';

import { ApiProvider, initializeApi } from './api';

import './fonts/free3of9.ttf';


import { SessionProvider } from './libraries/SessionProvider';

import { Toaster } from './libraries/Toaster';

import { UploadManager } from './libraries/UploadManager';
import { ScanWatcher } from './views/scanner/ScanWatcher';



void initializeApi();



LicenseInfo.setLicenseKey('a8d045b383d62f91c17ce30814a54c3cTz0xMjc4NjQsRT0xODIyMTc1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');





const theme = createTheme({

    /*

    palette: {

        primary: {

            main: '#181515',

        },

        secondary: {

            main: '#ff0101',

        },

        background: {

            default: '#fafbf5',

        },

    },*/

});











// setup io connector on client side

const ioInstance = 'io' in window ? window['io'] : null;



setIOInstance(ioInstance);



const sendProto = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.send = function (...args) {



    this.setRequestHeader('Frontend', '1');

    return sendProto.apply(this, args);

};







setAppDispatch((action: PayloadAction<any>) => {

    appStore.dispatch(action);

});



const container = document.getElementById('coreContainer');

const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(<ThemeProvider theme={theme}>

    <Provider store={appStore}>

        <PersistGate loading={null} persistor={persistor}>

            <ApiProvider>

                <SessionProvider>

                    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale='fr'>

                        <Persistor />



                        <GeoLocalizer />

                        <Broadcaster>
                            <ScanWatcher>

                                <UploadManager>



                                    <Toaster>
                                        <AppRoutes />
                                    </Toaster>

                                    <AppStatus />



                                </UploadManager>
                            </ScanWatcher>
                        </Broadcaster>

                    </LocalizationProvider>

                </SessionProvider>

            </ApiProvider>

        </PersistGate>

    </Provider>

</ThemeProvider>);
